export default __webpack_public_path__ + "static/media/eye_hover.5f65367f.png";